import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import Status from "../../../../Componets/Status";
import Table from "../../../../Componets/Table";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import tables from "../../../../Data/Tables/Customers/Statement/tables";
import headers from "../../../../Data/Tables/Customers/Statement/headers";
import Loadercomponent from "../../../../Componets/Loader";
import { get_all_invoices } from "../../../../Controllers/Sales/Invoices";
import DateTimeBadge from "../../../../Componets/DateTime/DateTimeBadge";
import { Button } from "antd";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { registerCairoFont } from "../../../Reports/cairo-font";
import UserCurrency from "../../../../Componets/UserCurrency";

const CustomerOutstandingStatement = () => {
  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [body, setBody] = useState([]);
  const [summary, setSummary] = useState({
    totalOutstanding: 0,
    totalInvoices: 0,
    overdueAmount: 0,
  });
  const { id } = useParams();
  localStorage.setItem("Customer_Id", id);

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const paginationdata = (data) => {
    let headerdata = {};
    header?.components?.map((value) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      payment: headerdata?.payment_status,
      date: headerdata?.date,
    });
  };

  const formdata = (data) => {
    let page = data?.search ? pagination?.currentPage : 1;
    fetchData({
      ...data,
      currentPage: page,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const calculateOutstanding = (invoice) => {
    const total = invoice.total || 0;
    const paid =
      invoice.payments?.reduce((sum, p) => sum + (p.amount || 0), 0) || 0;
    return total - paid;
  };

  const fetchSummary = async () => {
    try {
      const params = {
        customer: id,
        source: "Customer_Statement",
      };

      const response = await get_all_invoices(params);

      if (response?.status) {
        const invoices = response?.data?.data || [];
        let totalOutstanding = 0;
        let overdueAmount = 0;

        invoices.forEach((invoice) => {
          const outstanding = calculateOutstanding(invoice);
          totalOutstanding += outstanding;

          if (invoice.due_date && outstanding > 0) {
            if (new Date(invoice.due_date) < new Date()) {
              overdueAmount += outstanding;
            }
          }
        });

        setSummary({
          totalOutstanding,
          totalInvoices: response?.data?.totalCount || invoices.length,
          overdueAmount,
        });
      } else {
        toast.error("Failed to fetch summary");
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const params = {
        customer: id,
        search: tabledata?.search,
        payment: tabledata?.payment,
        delivery_status: tabledata?.delivery_status,
        date: tabledata?.date,
        page: tabledata?.currentPage,
        limit: 10,
      };

      const response = await get_all_invoices(params);

      if (response?.status) {
        let invoices = response?.data?.data || [];

        invoices = invoices.filter(
          (invoice) => calculateOutstanding(invoice) > 0,
        );

        const startIndex = ((params.page || 1) - 1) * params.limit;
        const paginatedInvoices = invoices.slice(
          startIndex,
          startIndex + params.limit,
        );

        const tableData = paginatedInvoices.map((invoice) => {
          const outstanding = calculateOutstanding(invoice);
          const paidAmount =
            invoice?.payments?.reduce(
              (sum, payment) => sum + Number(payment.amount || 0),
              0,
            ) || 0;

          const remainingAmount = (invoice?.total || 0) - paidAmount;
          return {
            path: `/app/billing/view/${invoice?._id}`,
            "Invoice No": `#${invoice.number}`,
            Date: <DateTimeBadge date={invoice?.date} />,
            "Due Date": invoice.due_date ? (
              <DateTimeBadge date={invoice?.due_date} />
            ) : (
              "-"
            ),
            "Total Amount": `${invoice.total?.toFixed(3)}`,
            "Paid Amount": invoice.payments?.length
              ? invoice.payments
                  .map((p) => `${p.name}: ${p.amount.toFixed(3)}`)
                  .join(", ")
              : "0.000",
            Outstanding: `${outstanding.toFixed(3)}`,
            "Payment Status":
              invoice?.payment_status == 2 ? (
                <div className="flex items-center gap-3 bg-emerald-50/50 px-3 py-2 rounded-lg border border-emerald-200">
                  <span className="text-emerald-600 font-medium text-sm">
                    Paid{" "}
                  </span>
                </div>
              ) : invoice?.payment_status == 1 ? (
                <div className="bg-amber-50/50 p-3 rounded-lg border border-amber-200 min-w-[150px]">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-amber-700 font-medium text-sm">
                      Partial
                    </span>
                    <span className="text-xs text-gray-500">
                      {(
                        (paidAmount / (paidAmount + remainingAmount)) *
                        100
                      ).toFixed(0)}
                      %
                    </span>
                  </div>
                  <div className="space-y-1.5">
                    <div className="flex justify-between text-sm">
                      <span className="text-gray-600">Paid</span>
                      <span className="text-emerald-600 font-semibold">
                        {paidAmount.toFixed(3)}
                      </span>
                    </div>
                    <div className="flex justify-between text-sm">
                      <span className="text-gray-600">Remaining</span>
                      <span className="text-red-600 font-semibold">
                        {remainingAmount.toFixed(3)}
                      </span>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="flex items-center gap-3 bg-red-50/50 px-3 py-2 rounded-lg border border-red-200">
                  <span className="text-red-600 font-medium text-sm">
                    Unpaid
                  </span>
                </div>
              ),
            "Delivery Status":
              invoice?.delivery_status == 2 ? (
                <span className="bg-green-100 text-green-600 text-sm px-2 py-1 rounded-lg">
                  Delivered
                </span>
              ) : invoice?.delivery_status == 1 ? (
                <span className="bg-yellow-100 text-yellow-600 text-sm px-2 py-1 rounded-lg">
                  Partial
                </span>
              ) : (
                <span className="bg-red-100 text-red-600 text-sm px-2 py-1 rounded-lg">
                  Pending
                </span>
              ),
          };
        });

        setBody(tableData);

        setPagination({
          currentPage: params.page || 1,
          totalCount: invoices.length,
          totalPages: Math.ceil(invoices.length / params.limit),
        });
      } else {
        toast.error("Failed to fetch invoices");
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoader(false);
    }
  };

  const fetchAllOutstanding = async () => {
    try {
      const params = {
        customer: id,
        source: "Customer_Statement",
      };

      const response = await get_all_invoices(params);

      if (!response?.status) return [];

      const invoices = response?.data?.data || [];

      return invoices
        .map((invoice) => {
          const paid =
            invoice.payments?.reduce(
              (sum, payment) => sum + (payment.amount || 0),
              0,
            ) || 0;

          return {
            invoiceNo: invoice.number,
            date: invoice.date,
            dueDate: invoice.due_date,
            total: invoice.total || 0,
            paid,
            outstanding: (invoice.total || 0) - paid,
            paymentStatus:
              invoice.payment_status === 2
                ? "Paid"
                : invoice.payment_status === 1
                  ? "Partial"
                  : "Unpaid",
            deliveryStatus:
              invoice.delivery_status === 2
                ? "Delivered"
                : invoice.delivery_status === 1
                  ? "Partial"
                  : "Pending",
          };
        })
        .filter((item) => item.outstanding > 0);
    } catch (error) {
      toast.error("Failed to fetch invoices");
      return [];
    }
  };

  const downloadCSV = async () => {
    const invoices = await fetchAllOutstanding();

    if (!invoices.length) {
      toast.error("No data available");
      return;
    }

    const headers = [
      "S.No",
      "Invoice No",
      "Date",
      "Due Date",
      "Total Amount",
      "Paid Amount",
      "Outstanding",
      "Payment Status",
    ];

    const csvContent = [
      headers.join(","),
      ...invoices.map((invoice, index) =>
        [
          index + 1,
          invoice.invoiceNo,
          new Date(invoice.date).toLocaleDateString(),
          invoice.dueDate
            ? new Date(invoice.dueDate).toLocaleDateString()
            : "-",
          invoice.total.toFixed(3),
          invoice.paid.toFixed(3),
          invoice.outstanding.toFixed(3),
          invoice.paymentStatus,
        ].join(","),
      ),
    ].join("\n");

    const blob = new Blob([new TextEncoder().encode("\uFEFF" + csvContent)], {
      type: "text/csv;charset=utf-8;",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `Customer_Outstanding_Report_${new Date()
      .toLocaleDateString()
      .replace(/\//g, "_")}.csv`;

    link.click();
  };

  const downloadPDF = async () => {
    const invoices = await fetchAllOutstanding();

    if (!invoices.length) {
      toast.error("No data available");
      return;
    }

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    registerCairoFont(doc);

    const pageWidth = doc.internal.pageSize.getWidth();

    doc.setFont("Cairo-Bold", "bold");
    doc.setFontSize(18);
    doc.text("Customer Outstanding Report", pageWidth / 2, 15, {
      align: "center",
    });

    doc.setFontSize(10);
    doc.text(
      `Downloaded on: ${new Date().toLocaleString()}`,
      pageWidth / 2,
      23,
      {
        align: "center",
      },
    );

    autoTable(doc, {
      startY: 30,
      head: [
        [
          "S.No",
          "Invoice No",
          "Date",
          "Due Date",
          "Total",
          "Paid",
          "Outstanding",
          "Payment",
        ],
      ],
      body: invoices.map((invoice, index) => [
        index + 1,
        invoice.invoiceNo,
        new Date(invoice.date).toLocaleDateString(),
        invoice.dueDate ? new Date(invoice.dueDate).toLocaleDateString() : "-",
        invoice.total.toFixed(3),
        invoice.paid.toFixed(3),
        invoice.outstanding.toFixed(3),
        invoice.paymentStatus,
      ]),
      styles: {
        font: "Cairo",
        lineWidth: 0.2,
        lineColor: [220, 220, 220],
      },
      headStyles: {
        font: "Cairo",
        fontStyle: "bold",
      },
    });

    doc.autoPrint();

    const pdfBlob = doc.output("blob");
    window.open(URL.createObjectURL(pdfBlob));
  };

  const headerReset = () => {
    let componentData = [];
    headers?.components?.map((value) => {
      componentData?.push({
        ...value,
        value: null,
      });
    });
    setHeader({ ...headers, components: componentData });
  };

  useEffect(() => {
    if (id) {
      fetchSummary();
      fetchData();
      headerReset();
    }
  }, [id]);

  return (
    <div>
      <Header headers={header} setHeaders={setHeader} formdata={formdata}>
        <div className="flex justify-end gap-3 mt-4 mb-4">
          <Button
            type="primary"
            className="form-save-button"
            onClick={downloadCSV}
          >
            Download Excel
          </Button>

          <Button
            type="primary"
            className="form-save-button"
            onClick={downloadPDF}
          >
            Download PDF
          </Button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6 pt-4">
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className=" text-gray-700 mb-2">Total Outstanding</h3>
            <p className=" text-red-600">
              <UserCurrency />  {summary.totalOutstanding.toFixed(3)}
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className=" text-gray-700 mb-2">Total Invoices</h3>
            <p className="text-green-600">{pagination.totalCount}</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className=" text-gray-700 mb-2">Overdue Amount</h3>
            <p className=" text-orange-600">
              <UserCurrency />  {summary.overdueAmount.toFixed(3)}
            </p>
          </div>
        </div>
        <Loadercomponent loader={loader}>
          <Table
            head={tables}
            body={body}
            pagination={pagination}
            paginationdata={paginationdata}
            summary={2}
          />
        </Loadercomponent>
      </Header>
    </div>
  );
};

export default CustomerOutstandingStatement;
